export default __webpack_public_path__ + "static/media/button_goback_zh_cn.49db5c9a.svg";